import { AdminListUserComplaintFilter } from '../../graphql/API';
import { adminListVenueComplaintCount } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminListVenueComplaintCountApi = async (
  filter: AdminListUserComplaintFilter,
): Promise<Record<string, number>> => {
  const result = await executeGql<string>(adminListVenueComplaintCount, { filter });
  return JSON.parse(processGqlResult<string>('adminListVenueComplaintCount', result));
};
